import {Component} from "@angular/core";
import {DateTime} from 'luxon';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss']
})

export class PrivacyComponent {
    public currentYear: string = DateTime.now().toFormat('y');
}